module.exports = __webpack_public_path__ + "static/media/icon-pantallas.f38aec23.svg";